const partnerQualificationList = [
  {code: "05", description: "Administrador"},
  {code: "08", description: "Conselheiro de Administração"},
  {code: "10", description: "Diretor"},
  {code: "16", description: "Presidente"},
  {code: "17", description: "Procurador"},
  {code: "18", description: "Secretário"},
  {code: "20", description: "Sociedade Consorciada"},
  {code: "21", description: "Sociedade Filiada"},
  {code: "22", description: "Sócio"},
  {code: "23", description: "Sócio Capitalista"},
  {code: "24", description: "Sócio Comanditado"},
  {code: "25", description: "Sócio Comanditário"},
  {code: "26", description: "Sócio de Indústria"},
  {code: "28", description: "Sócio-Gerente"},
  {code: "29", description: "Sócio Incapaz ou Relat.Incapaz (exceto menor)"},
  {code: "30", description: "Sócio Menor (Assistido/Representado)"},
  {code: "31", description: "Sócio Ostensivo"},
  {code: "33", description: "Tesoureiro"},
  {code: "37", description: "Sócio Pessoa Jurídica Domiciliado no Exterior"},
  {code: "38", description: "Sócio Pessoa Física Residente ou Domiciliado no Exterior"},
  {code: "47", description: "Sócio Pessoa Física Residente no Brasil"},
  {code: "48", description: "Sócio Pessoa Jurídica Domiciliado no Brasil"},
  {code: "49", description: "Sócio-Administrador"},
  {code: "52", description: "Sócio com Capital"},
  {code: "53", description: "Sócio sem Capital"},
  {code: "54", description: "Fundador"},
  {code: "55", description: "Sócio Comanditado Residente no Exterior"},
  {code: "56", description: "Sócio Comanditário Pessoa Física Residente no Exterior"},
  {code: "57", description: "Sócio Comanditário Pessoa Jurídica Domiciliado no Exterior"},
  {code: "58", description: "Sócio Comanditário Incapaz"},
  {code: "59", description: "Produtor Rural"},
  {code: "63", description: "Cotas em Tesouraria"},
  {code: "65", description: "Titular Pessoa Física Residente ou Domiciliado no Brasil"},
  {code: "66", description: "Titular Pessoa Física Residente ou Domiciliado no Exterior"},
  {code: "67", description: "Titular Pessoa Física Incapaz ou Relativamente Incapaz (exceto menor)"},
  {code: "68", description: "Titular Pessoa Física Menor (Assistido/Representado)"},
  {code: "70", description: "Administrador Residente ou Domiciliado no Exterior"},
  {code: "71", description: "Conselheiro de Administração Residente ou Domiciliado no Exterior"},
  {code: "72", description: "Diretor Residente ou Domiciliado no Exterior"},
  {code: "73", description: "Presidente Residente ou Domiciliado no Exterior"},
  {code: "74", description: "Sócio-Administrador Residente ou Domiciliado no Exterior"},
  {code: "75", description: "Fundador Residente ou Domiciliado no Exterior"},
  {code: "76", description: "Protetor"},
  {code: "77", description: "Vice-Presidente"},
  {code: "78", description: "Titular Pessoa Jurídica Domiciliada no Brasil"},
  {code: "79", description: "Titular Pessoa Jurídica Domiciliada no Exterior"}
]

export default partnerQualificationList